import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useLicenseMutation from "license/hooks/useLicenseMutation";
import { Button, ButtonToolbar } from "components/bootstrap";
import { ConfirmDialog } from "components/common";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const LicenseActions = ({ id, licenseId = void 0, contractId = void 0 }) => {
  const { t } = useTranslation("enterprise_license");
  const { deselectEntity } = useSelectedEntities();
  const { deleteLicense } = useLicenseMutation();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const sendTelemetry = useSendTelemetry("license");
  const cancelDelete = () => {
    setShowDeleteDialog(false);
    deselectEntity(id);
  };
  const handleDelete = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LICENSE.DELETED, {
      app_pathname: "license"
    });
    deleteLicense({ licenseId, contractId }).then(() => {
      deselectEntity(id);
      setShowDeleteDialog(false);
    });
  };
  const onDelete = () => {
    setShowDeleteDialog(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showDeleteDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showDeleteDialog,
      title: t("license.actions.delete_title"),
      onCancel: cancelDelete,
      onConfirm: handleDelete
    },
    /* @__PURE__ */ React.createElement("p", null, t("license.actions.delete_confirm", { license: licenseId != null ? licenseId : contractId }))
  ), /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", bsStyle: "danger", onClick: onDelete }, t("license.actions.delete"))));
};
export default LicenseActions;
